import _regeneratorRuntime from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _createClass from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Indicator, IndicatorInput } from "../indicator/indicator";
import LinkedList from "../Utils/FixedSizeLinkedList";
export var IchimokuCloudInput =
/*#__PURE__*/
function (_IndicatorInput) {
  _inherits(IchimokuCloudInput, _IndicatorInput);

  function IchimokuCloudInput() {
    var _this;

    _classCallCheck(this, IchimokuCloudInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(IchimokuCloudInput).apply(this, arguments));
    _this.conversionPeriod = 9;
    _this.basePeriod = 26;
    _this.spanPeriod = 52;
    _this.displacement = 26;
    return _this;
  }

  return IchimokuCloudInput;
}(IndicatorInput);
export var IchimokuCloudOutput = function IchimokuCloudOutput() {
  _classCallCheck(this, IchimokuCloudOutput);
};
export var IchimokuCloud =
/*#__PURE__*/
function (_Indicator) {
  _inherits(IchimokuCloud, _Indicator);

  function IchimokuCloud(input) {
    var _this2;

    _classCallCheck(this, IchimokuCloud);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(IchimokuCloud).call(this, input));
    _this2.result = [];
    var defaults = {
      conversionPeriod: 9,
      basePeriod: 26,
      spanPeriod: 52,
      displacement: 26
    };
    var params = Object.assign({}, defaults, input);
    var currentConversionData = new LinkedList(params.conversionPeriod * 2, true, true, false);
    var currentBaseData = new LinkedList(params.basePeriod * 2, true, true, false);
    var currenSpanData = new LinkedList(params.spanPeriod * 2, true, true, false);
    _this2.generator =
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var result, tick, period, periodCounter, conversionLine, baseLine, spanA, spanB;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              period = Math.max(params.conversionPeriod, params.basePeriod, params.spanPeriod, params.displacement);
              periodCounter = 1;
              _context.next = 4;
              return;

            case 4:
              tick = _context.sent;

            case 5:
              if (!true) {
                _context.next = 18;
                break;
              }

              // Keep a list of lows/highs for the max period
              currentConversionData.push(tick.high);
              currentConversionData.push(tick.low);
              currentBaseData.push(tick.high);
              currentBaseData.push(tick.low);
              currenSpanData.push(tick.high);
              currenSpanData.push(tick.low);

              if (periodCounter < period) {
                periodCounter++;
              } else {
                // Tenkan-sen (ConversionLine): (9-period high + 9-period low)/2))
                conversionLine = (currentConversionData.periodHigh + currentConversionData.periodLow) / 2; // Kijun-sen (Base Line): (26-period high + 26-period low)/2))

                baseLine = (currentBaseData.periodHigh + currentBaseData.periodLow) / 2; // Senkou Span A (Leading Span A): (Conversion Line + Base Line)/2))

                spanA = (conversionLine + baseLine) / 2; // Senkou Span B (Leading Span B): (52-period high + 52-period low)/2))

                spanB = (currenSpanData.periodHigh + currenSpanData.periodLow) / 2; // Senkou Span A / Senkou Span B offset by 26 periods
                // if(spanCounter < params.displacement) {
                // 	spanCounter++
                // } else {
                // 	spanA = spanAs.shift()
                // 	spanB = spanBs.shift()
                // }

                result = {
                  conversion: conversionLine,
                  base: baseLine,
                  spanA: spanA,
                  spanB: spanB
                };
              }

              _context.next = 15;
              return result;

            case 15:
              tick = _context.sent;
              _context.next = 5;
              break;

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })();

    _this2.generator.next();

    input.low.forEach(function (tick, index) {
      var result = _this2.generator.next({
        high: input.high[index],
        low: input.low[index]
      });

      if (result.value) {
        _this2.result.push(result.value);
      }
    });
    return _this2;
  }

  _createClass(IchimokuCloud, [{
    key: "nextValue",
    value: function nextValue(price) {
      return this.generator.next(price).value;
    }
  }]);

  return IchimokuCloud;
}(Indicator);
IchimokuCloud.calculate = ichimokucloud;
export function ichimokucloud(input) {
  Indicator.reverseInputs(input);
  var result = new IchimokuCloud(input).result;

  if (input.reversedInput) {
    result.reverse();
  }

  Indicator.reverseInputs(input);
  return result;
}